import script from "./ConsumerProductList.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerProductList.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerProductList.vue?vue&type=style&index=0&id=6cb4be74&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cb4be74"]])

export default __exports__